var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion } from './Accordion';
import { StudentTutorial, } from '../../../Tutorials/StudentTutorial';
var FirstRunAccordion = function (_a) {
    var onPlayVideo = _a.onPlayVideo, studentsRateTarget = _a.studentsRateTarget, grade = _a.grade, yearlyDashboardLink = _a.yearlyDashboardLink, weeklyDashboardLink = _a.weeklyDashboardLink, placementTestAvailable = _a.placementTestAvailable, rest = __rest(_a, ["onPlayVideo", "studentsRateTarget", "grade", "yearlyDashboardLink", "weeklyDashboardLink", "placementTestAvailable"]);
    var isPrekWithoutPlacementTest = grade === -1 && !placementTestAvailable;
    return (_jsx(Accordion, __assign({}, rest, { label: 'First run', header: isPrekWithoutPlacementTest
            ? 'Students will complete their first task and start learning'
            : 'Students will complete the Placement Test and begin learning', tooltipContent: "This step will be checked off after at least " + studentsRateTarget + "% of students complete their first learning task" }, { children: _jsx(StudentTutorial, { grade: grade, yearlyDashboardLink: yearlyDashboardLink, weeklyDashboardLink: weeklyDashboardLink, onPlayVideo: onPlayVideo }, void 0) }), void 0));
};
export { FirstRunAccordion };
